// extracted by mini-css-extract-plugin
module.exports = {"title":"loader_title___b5ZH","sub_title":"loader_sub_title__N7o8R","grid":"loader_grid__34iro"};